import { render, staticRenderFns } from "./tabs-mu-ban.vue?vue&type=template&id=0c3ee9cb&scoped=true"
import script from "./tabs-mu-ban.vue?vue&type=script&lang=js"
export * from "./tabs-mu-ban.vue?vue&type=script&lang=js"
import style0 from "./tabs-mu-ban.vue?vue&type=style&index=0&id=0c3ee9cb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3ee9cb",
  null
  
)

export default component.exports